import { getAxiosClientWithToken } from './index';
import { SearchLogRequest } from 'app/slice/searchLogSlice';

export const searchLogClick = (searchLogRequest: SearchLogRequest) => {
    const { type, purpose, keyword } = searchLogRequest;
    const restClient = getAxiosClientWithToken();
    return restClient.post(`/company/search-log`, { type, purpose, keyword });
};
